var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiskaMainCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "378.987 129.987 121.175 118.946",
    width: "50px",
    height: "50px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,600 H 800 V 0 H 0 Z",
    id: "path18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(0.774503, 0, -0.002857, -0.759759, 135.392929, 518.049011)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "matrix(1, 0, 0, 1, 247.296753, 98.619835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    clipPath: "url(#clipPath20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(224.8801,333.8709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-43.069 -34.914,-77.985 -77.985,-77.985 -43.07,0 -77.984,34.916 -77.984,77.985 0,43.069 34.914,77.985 77.984,77.985 C -34.914,77.985 0,43.069 0,0",
    style: {
      fill: "#f04e51",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(172.0575,378.6562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 7.808,0 13.101,-4.733 13.101,-14.626 13.101,-24.53 7.667,-28.287 0,-28.287 h -22.706 v -9.624 h 15.053 c 7.8,0 14.069,-2.368 14.069,-12.261 0,-9.896 -6.41,-12.4 -14.069,-12.4 h -15.053 v -17.285 c 0,-9.619 -4.044,-13.514 -14.498,-13.514 h -2.782 c -10.876,0 -14.498,3.895 -14.498,13.514 v 66.071 c 0,9.887 4.042,13.786 14.498,13.786 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiskaMainCircle);
export default __webpack_public_path__ + "static/media/fiskaMainCircle.0d3167de8a63cb4828c1d95029c466ba.svg";
export { ForwardRef as ReactComponent };